import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function equityChangeStatement(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@equityChangeStatement/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@equityChangeStatement/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@equityChangeStatement/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}